import Header from '../Header/Navbar';
import Button from '../Button/Button';
// import Fearures from '../Features/Features';
// import PricePackages from '../Pricing/PricingPackages';
import FAQ from '../FAQ/FAQ';
import Footer from '../Footer/Footer';
import { SIGNUP_FORM_LINK } from '../../App';

export default function Home() {
  const icons = [
    'McpIcon.svg',
    'github.svg',
    'Supabase.svg',
    'MicrosoftAzure.svg',
    'AmazonIcon.svg',
    'googlecloud.svg',
    'firebase.svg',
    'googleanalytics.svg',
    'snapchat.svg',
    'linearIcon.svg',
    'ClickUp.svg',
    'MegaMenu.svg',
    'NotionIcon.svg',
  ];
  return (
    <div>
      <Header />
      <div
        className='bg-cover bg-center relative py-5 text-center pt-20 pb-0 bg-white '
        style={{
          backgroundImage:
            "url('/HeroCircleGradient.svg')",
        }}
      >
        <div className='container max-auto'>
          <div className='flex-inline flex-col text-center '>
            <div className='inline-flex items-center justify-center bg-primary40 rounded-full font-sora text-[16px] text-darktext mx-auto relative px-[1px] pr-4 sm:mb-1'>
              <img
                src='/EmojiIcon.svg'
                alt='Emoji Icon'
                className='relative top-[5px] '
              />
              It's Pale here!
            </div>
            <h3 className='text-center text-primary sm:text-[24px] sm:leading-[33px] md:text-[35px]'>
              AI Phone Answering
            </h3>
            <p className='font-noto text-[23px] text-black40 sm:text-[15px] md:text-[20px] mb-[150px]'>
              Never miss a call again.
            </p>
            <a
              href={SIGNUP_FORM_LINK}
              target='_blank'
              rel='noreferrer'
            >
              <Button
                variant='primary'
                className='py-[16px] px-[32px] mt-5'
              >
                Sign up to waitlist
              </Button>
            </a>
          </div>
          <div className='text-center mx-auto inline-flex flex-col justify-center '>
            
            {/* <img
              src='/ui/HeroT.webp'
              alt='Hero Img'
              className='pt-24 block sm:hidden'
            />
            <img
              src='/ui/HeroTSmall.webp'
              alt='Hero Img'
              className='pt-12 h-full w-screen hidden sm:block '
            /> */}
          </div>
        </div>
      </div>
      {/* hero section end */}
      {/* <Fearures /> */}
      {/* <div className='relative py-[100px]'>
        <div className='container mx-auto'>
          <div
            className='bg-cover rounded-[24px] py-16 text-center'
            style={{
              backgroundImage:
                "url('/texturebg.svg')",
            }}
          >
            <div className='inline-flex items-center justify-center bg-[#ffffff80] rounded-full font-sora text-[16px] text-darktext mx-auto relative px-[1px] pr-4'>
              <img
                src='/EmojiIcon.svg'
                alt='Emoji Icon'
                className='relative top-[5px]'
              />
              Hook me up without headache
            </div>
            <h3 className='text-center mx-auto sm:text-[31px] sm:leading-[38px] '>
              I'm fluent in over <br />
              <strong>100+</strong> Apps via MCP
            </h3>
            <div className='marquee overflow-hidden w-full py-5 pb-2'>
              <div className='marquee-track flex items-center gap-7'>
                {icons.map((icon, i) => (
                  <div
                    key={`a-${i}`}
                    className='bg-white w-[60px] h-[60px] rounded-full border border-[#0505051a] flex justify-center items-center overflow-hidden transition duration-700 ease-in-out hover:scale-125'
                  >
                    <img
                      src={`/app-icon/${icon}`}
                      alt='Icon'
                    />
                  </div>
                ))}
                {icons.map((icon, i) => (
                  <div
                    key={`b-${i}`}
                    className='bg-white w-[60px] h-[60px] rounded-full border border-[#0505051a] flex justify-center items-center overflow-hidden transition duration-700 ease-in-out hover:scale-125'
                    aria-hidden='true'
                  >
                    <img
                      src={`/app-icon/${icon}`}
                      alt='Icon'
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <AboutMe/> */}
      {/* <PricePackages /> */}
      {/* <FAQ /> */}
      {/* <div className='bg-white py-20 border-b-[1px] border-[#0000001a] relative object-cover'>
        <img
          src='/shadowbg-img.svg'
          alt=''
          className='absolute top-[-250px] w-full bottom-0 left-0 right-0 mx-auto object-cover sm:top-[0px]'
        />
        <div className='container mx-auto text-center'>
          <h3 className='text-primary text-center sm:text-[31px] sm:leading-[40px] sm:mb-2'>
            I'm ready to prove myself -{' '}
            <strong className='block font-semibold text-[#0000004d]'>
              Are you?
            </strong>
          </h3>
          <a
            href={SIGNUP_FORM_LINK}
            target='_blank'
            rel='noreferrer'
          >
            <Button
              variant='primary'
              className='py-[16px] px-[32px] mt-5 !text-[18px]'
            >
              Sign up to waitlist
            </Button>
          </a>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}
